/**
 * "New task", asked for from somewhere that is not the Tasks page.
 *
 * A message's menu offers "Create a task from this". The chat feature must not
 * import the task form to do it — the form, the people picker and the task
 * rules would all land in the chat chunk. So it says what it wants to a store
 * of a few lines, and `TaskComposerHost` (mounted once, in the shell) is what
 * loads the form and shows it.
 */
import { createStore } from '@/lib/tinyStore';
import type { TaskFormSeed } from './lib/taskForm';

interface TaskComposerState {
  /** What the form opens with. `null` while no form is asked for. */
  seed: TaskFormSeed | null;
}

export const taskComposerStore = createStore<TaskComposerState>({ seed: null });

export const selectComposerSeed = (state: TaskComposerState): TaskFormSeed | null => state.seed;

export const taskComposer = {
  open(seed: TaskFormSeed = {}): void {
    taskComposerStore.set({ seed });
  },
  close(): void {
    taskComposerStore.set({ seed: null });
  },
};
